import React from 'react';
import style from './Assumptions.css';

const Assumptions = () => {
    return (
        <div className={"sources-wrapper"}>
            <div>
                <div className={'sources'}>
                    <p>
                        1. Assuming a dealership of 10 salespeople with 3 cars taken out per day
                    </p>
                    <p>
                        2. Assuming 0.5 cars sales lost per day per employee, an average profit per car of $3,000 and a
                        close rate of 12.4%
                    </p>
                    <p>
                        <a href=" https://www.ipsos.com/en-ca/news-polls/canadians-looking-for-an-easier-vehicle-purchasing-experience" target={'_blank'}>
                            3. Source: IPSOS
                        </a>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Assumptions;